import React, { useState, useContext, useEffect } from "react";
import "./Navbar.css";
import { ThemeContext } from "../../../contexts/themeContext";
import { AuthContext } from "../../../contexts/authContext";
import logoImg from "../../../assets/images/Almuntazar_tv.png";
import { NavLink, useLocation } from "react-router-dom";

const Navbar = ({ isLoggedIn }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const { handleLogout } = useContext(AuthContext);

  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };

  useEffect(() => {
    // close the menu whenever the route changes
    setIsMenuOpen(false);
  }, [location]);

  return (
    <header className={isDarkMode ? "dark-mode" : "light-mode"}>
      <nav>
        <NavLink to="/"><img src={logoImg} alt="Logo" className="logo-img" width={'72px'} /></NavLink>
        <div className="right-nav">
          <div
            className={`hamburger ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className={`nav-links ${isMenuOpen ? "show" : ""}`} id="navLinks">
            <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")}>
              Home
            </NavLink>
            <NavLink to="/Gallery" className={({ isActive }) => (isActive ? "active" : "")}>
              Gallery
            </NavLink>
            <NavLink to="/About" className={({ isActive }) => (isActive ? "active" : "")}>
              About Us
            </NavLink>
            <NavLink to="/AIM" className={({ isActive }) => (isActive ? "active" : "")}>
              History of AIM
            </NavLink>
            <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : "")}>
              Contact us
            </NavLink>



            {isLoggedIn && (
              <NavLink to="/quiz" className={({ isActive }) => (isActive ? "active" : "")}>
                Quiz
              </NavLink>
            )}

            {isLoggedIn && <button onClick={handleLogout}>Logout</button>}
            {/* <button className="toggle-btn" onClick={toggleTheme}>
                {isDarkMode ? "☀️" : "🌙"}
              </button> */}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
